import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

export type UserPermissionsResponse = {
  permissions: string[];
};

async function getUserPermissions(): Promise<UserPermissionsResponse> {
  const api = await getApi();
  const { data } = await api.get<UserPermissionsResponse>('get_permissions/');
  return data;
}

type QueryFnType = typeof getUserPermissions;

function useUserPermissions(enabled: boolean = true) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['user-permissions'],
    queryFn: () => getUserPermissions(),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });
}

export { getUserPermissions, useUserPermissions };